import { Handle, Position } from 'reactflow';
import { Box, Typography } from '@mui/material';
import { IconUsers, IconEdit } from '@tabler/icons-react';
import '../styles/nodes.css';
import { useOrganogramContext } from '../hooks/useOrganogramContext';

export function OrgNode({ data, id }) {
    const { openModal } = useOrganogramContext();

    return (
        <Box className="org-node-wrapper">
            <Handle
                type="target"
                position={Position.Top}
                className="org-node-handle"
            />

            <Box
                className="org-node-card group"
                onClick={() =>
                    openModal({
                        id,
                        ...data
                    })
                }
            >
                <Box className="org-node-content">
                    <Typography variant="subtitle1" className="org-node-title">
                        {data.title}
                    </Typography>
                    <Box className="org-node-members-count">
                        <IconUsers size={12} />
                        <Typography variant="caption">
                            {data.members.length}
                        </Typography>
                    </Box>
                </Box>
                <Box className="org-node-edit-indicator">
                    <IconEdit size={12} className="edit-icon" />
                </Box>
            </Box>

            <Handle
                type="source"
                position={Position.Bottom}
                className="org-node-handle"
            />
        </Box>
    );
}
